import { InjectionToken } from '@angular/core';

/**
 * The apex domain the fallback device cookie is written at. Without one the cookie is host-only, so
 * the same visitor is a different device on the apex than on each subdomain.
 */
export const DEVICE_ID_COOKIE_DOMAIN = new InjectionToken<string | undefined>('DEVICE_ID_COOKIE_DOMAIN');
